<template>
  <div class="component-wrapper">
    <h3>Manage District Profile and Units</h3>
    <p v-if="msg">{{ msg }}</p>
    <div class="app-form">
      <div class="district-inputs">
        <div class="input-wrapper">
          <p>District Access Code: {{ districtCode }}</p>
        </div>
        <div class="input-wrapper">
          <label for="districtName">District Name: </label>
          <input type="text" id="districtName" v-model="districtName">
        </div>
        <div class="input-wrapper">
          <label for="districtCity">District City: </label>
          <input type="text" id="districtCity" v-model="districtCity">
        </div>
        <div class="input-wrapper">
          <label for="districtState">District State: </label>
          <input type="text" id="districtState" v-model="districtState">
        </div>
      </div>
      <table>
        <tr>
          <th>Unit</th>
          <th>Title</th>
          <th>Purchased</th>
        </tr>
        <tr v-for="unit in units" :key="unit.unitId">
          <td>{{unit.unitId}}</td>
          <td>{{unit.unitTitle}}</td>
          <td><input type="checkbox" :value="unit.unitId" v-model="purchasedUnits"/></td>
        </tr>
      </table>
      <button type="button" @click.prevent="updateDistrict">Update District</button>
      <button type="button" @click.prevent="cancelManage">Cancel</button>
    </div>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')
import { mapState } from 'vuex'

export default {
  data() {
    return{
      districtCode: '',
      districtName: '',
      districtCity: '',
      districtState: '',
      purchasedUnits: [],
      units: [],
      msg: null
    }
  },
  computed: {
    ...mapState([ 'districtId', 'userProfile' ])
  },
  methods: {
    cancelManage() {
      this.$store.commit('SET_DISTRICT_ID', null)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
    },
    fetchDistrict() {
      fb.districtsCollection.doc(this.districtId).get().then((doc) => {
        if (doc.exists) {
          console.log('Doc data: ', doc.data())
          this.districtCode = doc.data().districtCode
          this.districtName = doc.data().districtName
          this.districtCity = doc.data().districtCity
          this.districtState = doc.data().districtState
          this.purchasedUnits = doc.data().units
        } else {
          console.log('no doc')
        }
      }).catch((err) => {
        console.log('Error: ', err)
      })
    },
    updateDistrict() {
      fb.districtsCollection.doc(this.districtId).update({
        districtName: this.districtName,
        districtCity: this.districtCity,
        districtState: this.districtState,
        units: this.purchasedUnits,
        updatedBy: this.userProfile.userId,
        updatedAt: new Date()
      }).then(() => {
        console.log('district has been updated')
        this.$store.commit('SET_GENERAL_MSG', '** District Updated Successfully **')
        this.$store.commit('SET_DISTRICT_ID', null)
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
      }).catch((err) => {
        console.log('Error updating:', err)
      })
    },
    fetchUnits() {
      fb.unitsCollection.orderBy('orderBy').get().then((snap) => {
        snap.forEach((doc) => {
          this.units.push(doc.data())
        })
      })
    },
    updatePurchased() {
      this.units.forEach((element) => {
        if (this.purchasedUnits.includes(element.unitId)) {
          element.purchased = true
        }
      })
    }
  },
  mounted() {
    this.fetchUnits()
    this.fetchDistrict()
  }
}
</script>

<style lang="css" scoped>
.district-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 20px;
}
table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
}
th, td {
  padding: 15px;
  border-bottom: 1px solid #cecece;
}
th {
  background: #0e314d;
  color: white;
  font-weight: 600;
  font-size: 1.2em
}
tr:nth-child(even) {
  background: #f7f7f7;
}
</style>
